
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 18 18"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"stroke":"#798F8F","stroke-linecap":"round","d":"M5.584 3.004v-.629c0-.483.373-.875.833-.875h4.752a1 1 0 0 1 .707.293l3.415 3.414a1 1 0 0 1 .293.707v8.25"}}),_c('path',{attrs:{"stroke":"#798F8F","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":".988","d":"m1.609 4.5 8.786 2.12.91 4.546 1.198 1.224-3.031 2.99-1.198-1.185-4.544-.909zm0 0 4.597 4.597m2.068.857a1.212 1.212 0 1 1-2.424 0 1.212 1.212 0 0 1 2.424 0"}})])
          )
        }
      }
    